// The onboarding questions Thisway answers on the restaurant's behalf.
//
// The API fills these on the Stripe account immediately before the onboarding
// surfaces are minted (ConnectAccountPrefill). This is the other half: Stripe's
// embedded form is told not to draw them, so the restaurant is never asked
// something we already sent.
//
// The codes are Stripe's own, the same ones connect-requirements.js maps to
// labels — so the two lists cannot drift into describing different fields.
export const PREFILLED_BY_THISWAY = [
  'business_profile.mcc',
  'business_profile.product_description',
  'business_profile.support_phone',
  'business_profile.support_address',
  'settings.payments.statement_descriptor',
];

const GROUPS = ['pastDue', 'currentlyDue', 'eventuallyDue'];

const outstandingCodes = (requirements) => {
  const codes = new Set();
  GROUPS.forEach((group) => {
    const list = requirements?.[group];
    if (!Array.isArray(list)) return;
    list.forEach((code) => {
      if (typeof code === 'string' && code.trim()) codes.add(code.trim());
    });
  });
  return codes;
};

/**
 * What to hide from Stripe's onboarding form, given what Stripe still says is
 * outstanding.
 *
 * Hiding is not the same as satisfying — Stripe's own words: "The exclude
 * option doesn't remove a requirement, it only prevents collection at the
 * time." So a field that is STILL outstanding is one our prefill did not
 * manage to set, and hiding it would leave the restaurant finishing a form
 * that can never complete its account, with nothing on screen to fix.
 *
 * Hence: hide only what Stripe no longer asks for. When the prefill worked,
 * that is all five and the restaurant sees none of them. When it failed —
 * the API swallows Stripe errors there on purpose — the field comes back and
 * they can answer it themselves.
 *
 * Returns undefined when there is nothing to hide, so the component is left
 * exactly as it is today rather than handed an empty instruction.
 */
export const onboardingCollectionOptions = (requirements) => {
  const outstanding = outstandingCodes(requirements);
  const exclude = PREFILLED_BY_THISWAY.filter((code) => !outstanding.has(code));
  if (!exclude.length) return undefined;
  return { fields: 'currently_due', requirements: { exclude } };
};
